import { ControlSheetNoteDTO } from '@/types/controlsheet'
import { ControlSheetNote } from '../types/types'

export const noteSorter = (a: ControlSheetNote, b: ControlSheetNote) => a.createdAt.getTime() - b.createdAt.getTime()

export const noteMapper =
    (annotationId: string) =>
    (note: ControlSheetNoteDTO): ControlSheetNote => ({
        annotationId: annotationId,
        id: note.id,
        note: note.note,
        createdAt: new Date(note.createdAt),
        author: note.userShift.authorName,
    })
